import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <AppSection />
        <CarouselSection />
        <ContactSection />
        <CommentsSection />
        <UpdatesSection />
        <TopicsSection />
        <RankingSection />
        <FeaturesSection />
        <FaqSection />
        <IndexSection />
        <AboutSection />
        <CardsSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}